const defaultBtn = [
  {
    id: 1,
    image:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/7c292d34540f52de7548b4991b07c737.png',
    text: '美团外卖',
    toast: '美团外卖频道',
    launchUrlApp: 'imeituan://www.meituan.com/search/result?entrance=0&q=',
    appSearch: true, //是否可以输入搜索关键字
    username: 'gh_870576f3c6f9',
    path: 'waimai/packages/index/search/search.html?entranceId=0&cateType=0&subCateType=0&keyword=',
    minSearch: true,
    buried: 'BG_JTCSM_WM_MT',
    clickBuried: 'CLICK_JTCSM_WM_MT'
  },
  {
    id: 2,
    image:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/13c0c2839473c15ccdf34eeed899fa2d.png',
    text: '饿了么',
    toast: '饿了么',
    launchUrlApp: 'eleme://',
    appSearch: true, //是否可以输入搜索关键字
    username: 'gh_6506303a12bb',
    path: 'ele-search/pages/search-result/search-result.html?keyword=',
    minSearch: true,
    buried: 'BG_JTCSM_WM_ELM',
    clickBuried: 'CLICK_JTCSM_WM_ELM'
  }
]
const hemaBtn = [
  {
    id: 3,
    image:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/c68243ac27cf4e4c56b71d347e384c1e.png',
    text: '盒马鲜生',
    toast: '盒马鲜生小程序',
    launchUrlApp: '',
    appSearch: true, //是否可以输入搜索关键字
    username: 'gh_290a9c77ddc3',
    path: 'act/ItemList/index.html?keyp=normalkeywords&keyword=',
    minSearch: true,
    buried: 'BG_JTCSM_WM_HEMA',
    clickBuried: 'CLICK_JTCSM_WM_HEMA'
  }
]
const defaultBanner = {
  banner1Data: [
    {
      title: '今天吃什么v2',
      img: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/8185c4979ddb81fef5a7e8336fcbc14a.jpg',
      router: {
        path: '/miniProgram',
        params: [
          {
            key: 'userName',
            value: 'gh_0d804ee2c21b'
          },
          {
            key: 'path',
            value:
              'pages/image-page/index?url=https%3A%2F%2Fcdnvue.gymcity.com.cn%2Fbetterwe_1.0%2Fvue%2F9e7e28d5be08a56c56a54e113da4524d.png'
          }
        ]
      }
    }
  ],
  banner2Data: [
    {
      title: '今天吃什么v2',
      img: 'https://cdnvue.gymcity.com.cn/uploads/bd9358f647cb2eab260a2c5994555cb6_wh=504_324.png',
      router: {
        path: '/wmOtherPage',
        params: [
          {
            key: 'url',
            value: 'http://t.weimob.com/C0_Gg5p'
          },
          {
            key: 'title',
            value: '吸油纸'
          },
          {
            key: 'fromType',
            value: 11
          }
        ]
      }
    }
  ]
}
export { defaultBtn, hemaBtn, defaultBanner }
